import { mapResultDecisionStatusToColor } from 'KnmErknmPackage/ErknmResultDecisionsModule/constants/mapResultDecisionStatusToColor';
import { KnmResultDecisionStatusEnum } from 'APIPackage/KnmModule/enums/KnmResultDecisionStatusEnum';
import { mapResultDecisionStatusToLabel } from 'KnmErknmPackage/ErknmResultDecisionsModule/constants/mapResultDecisionStatusToLabel';
import { KnmResultDecisionAgreementStatusEnum } from 'APIPackage/KnmModule/enums/KnmResultDecisionAgreementStatusEnum';

import styles from './ResultDecisionStatus.module.scss';
import { mapResultDecisionAgreementStatusToColor } from '../constants/mapResultDecisionAgreementStatusToColor';
import { mapResultDecisionAgreementStatusToLabel } from '../constants/mapResultDecisionAgreementStatusToLabel';

interface IResultDecisionStatusProps {
  status: KnmResultDecisionStatusEnum | undefined;
  agreementStatus: KnmResultDecisionAgreementStatusEnum | undefined;
  isPaperless: boolean;
  isNew: boolean | undefined;
}

export const ResultDecisionStatus = ({ status, agreementStatus, isPaperless, isNew }: IResultDecisionStatusProps) => {
  if (isPaperless && isNew) {
    return <div className={styles.ActStatus}>Черновик</div>;
  }

  if (!status) {
    return null;
  }

  return (
    <div className={styles.Wrapper}>
      {!!agreementStatus && (
        <div
          className={styles.ResultDecisionStatus}
          data-color={mapResultDecisionAgreementStatusToColor[agreementStatus]}
        >
          {mapResultDecisionAgreementStatusToLabel[agreementStatus]}
        </div>
      )}
      <div className={styles.ResultDecisionStatus} data-color={mapResultDecisionStatusToColor[status]}>
        {mapResultDecisionStatusToLabel[status]}
      </div>
    </div>
  );
};
